/**
 * One clip scan for every action path.
 *
 * The executor walks a mutable draft and needs the live clip object back so it
 * can patch it in place, while the validator and the inverse generator read a
 * frozen project, so the shape is generic over the clip rather than pinned to
 * Clip. Four hand-written copies of this loop had already drifted apart on what
 * "not found" means, three returning null and one undefined.
 */
export function findClipInTracks<T extends { id: string }>(
  tracks: ReadonlyArray<{ readonly clips: readonly T[] }>,
  clipId: string,
): T | null {
  for (const track of tracks) {
    const clip = track.clips.find((c) => c.id === clipId);
    if (clip) return clip;
  }
  return null;
}
